import { SESSION } from '@voicebase/gatekeeper';
import _ from 'lodash';

import { gatekeeper } from './users/';
import { providers } from './users/usersReducers';

import * as C from './users/userConstants';
import * as CS from './sharedConstants';

const SITE_DOMAIN = process.env.SITE_DOMAIN;

export default function gatekeeperMiddleware(store) {
  return next => (action) => {
    const { type, payload } = action;

    const state = store.getState();
    if (!state.users) {
      console.log('skipping - no user');
      next(action);
      return;
    }
    const users = state.users;

    try {
      switch (type) {
        case C.A_SET_EPHEMERAL_KEY:

          break;

        case C.A_INIT_GATEKEEPER:
          if (!users.listeningToSession) {
            store.dispatch(providers.listeningToSession());
            gatekeeper.addEventListener(SESSION, (session) => {
              const info = (_.get(session, 'detail.session', null));
              store.dispatch(providers.setSession(info));
            });
          }
          if (!users.startedGatekeeper) {
            store.dispatch(providers.gatekeeperStarted());
            gatekeeper.start();
          }
          break;

        case C.A_SET_ACCESS_TOKEN:
          if (payload) {
            store.dispatch(providers.setProfileStatus(CS.LOADING));
            gatekeeper.getProfile(payload)
              .then((profile) => {
                store.dispatch(providers.setProfile(profile));
                store.dispatch(providers.setProfileStatus(profile ? CS.LOADED : CS.NOT_LOADED));
                store.dispatch(providers.setGatekeeperStatus(profile? CS.LOADED : CS.NOT_LOADED));
              })
              .catch((err) => {
                gatekeeper.logout();
              });
          }
          break;

        case C.A_INIT_GATEKEEPER_CALLBACK:

          if (!users.listeningToSession) {
            store.dispatch(providers.listeningToSession());
            gatekeeper.addEventListener(SESSION, (session) => {
              const userInfo = _.get(session, 'detail.session', null);
              store.dispatch(providers.setSession(userInfo));
            });
          }

          if (!users.startedGatekeeperCallback) {
            store.dispatch(providers.startGatekeeperCallback());
            gatekeeper.gatekeeperCallbackStarted();
          }
          break;

        case C.A_LOG_IN_WITH_AUTH0:
          store.dispatch(providers.setProfileStatus(CS.LOADING));
          requestAnimationFrame(() => gatekeeper.authorize());
          break;

        case C.A_LOG_OUT_WITH_AUTH0:
          requestAnimationFrame(() => gatekeeper.terminate({
            returnTo: SITE_DOMAIN,
          }));
          break;
        default:
        // noop
      }
    } catch (err) {
      console.log('gatekeeper start error:', err, action);
      store.dispatch(providers.setProfileStatus(CS.LOAD_ERROR));
    }

    next(action);
  };
}

